<app-order-create-layout
  data-testid="order-create-form"
  #addForm
  [titleKey]="'order.internal.create_order'"
  [headerActions]="headerActions"
  [formFields]="formFields"
  [tableSections]="tableSections"
  [summarySection]="summarySection"
  [loading]="loading"
  [initialData]="formData"
  [hideProductSearch]="false"
  [isDisableCoupon]="true"
  (formAction)="onFormAction($event)"
  (tableAction)="onTableAction($event)"
  (productSearch)="onProductSearchField($event)"
  (productSelect)="onProductSearchSelect($event)"
></app-order-create-layout>
<!-- Product Selection Dialog -->
<app-product-selection-dialog
  data-testid="order-create-product-selection-dialog"
  [visible]="showProductSelectionDialog"
  [products]="productDialogProducts"
  [loading]="productDialogLoading"
  [totalRecords]="productDialogTotalRecords"
  (visibleChange)="onProductSelectionDialogVisibleChange($event)"
  (selectionConfirm)="onProductSelectionConfirm($event)"
  (search)="onProductSearch($event)"
  (searchReset)="onProductSearchReset()"
  (pageChange)="onProductPageChange($event)"
></app-product-selection-dialog>

<!-- Toast component for order creation notifications -->
<p-toast data-testid="order-create-toast"></p-toast>
